import { PERMISSIONS } from "../enums/QueryKeys";
import { useQuery } from "@tanstack/react-query";
import useUser from "./useUser";
import { fetchPermissions, fetchPermissionsForEmployee } from "../enums/queryFunction/Fetch";
import { EMPLOYEE_PERMISSIONS } from "../enums/ApiPaths";

export function useGetClinicPermissionsForEmployee(userId) {
  const { isLoading: userLoading } = useUser();

   const { data, isLoading, error } = useQuery({
     queryKey: [PERMISSIONS,userId],
     queryFn: () => fetchPermissionsForEmployee(userId),
     staleTime: Infinity,
     enabled: !userLoading,
   });
 
  return { data, isLoading, error };
}
